// Affiliate link helper.
// Wraps a plain seller URL in a tracked Awin link when we have an affiliate
// programme for that seller. Anything else is returned unchanged.
// Keep using the PLAIN url for price checking; use affiliateUrl() only for
// what the visitor clicks (the Book button).

const AWIN_PUBLISHER_ID = "3142832";

// host (without "www.") -> Awin advertiser id
const AWIN_PROGRAMMES = {
  "theatreticketsdirect.co.uk": "1936",
};

function hostOf(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, "").toLowerCase();
  } catch {
    return "";
  }
}

export function affiliateUrl(url) {
  if (!url) return url;
  const mid = AWIN_PROGRAMMES[hostOf(url)];
  if (!mid) return url;
  return (
    "https://www.awin1.com/cread.php" +
    `?awinmid=${mid}&awinaffid=${AWIN_PUBLISHER_ID}` +
    `&ued=${encodeURIComponent(url)}`
  );
}

export function isAffiliate(url) {
  return !!AWIN_PROGRAMMES[hostOf(url)];
}